type PasswordDoc = { mustChangePassword?: boolean; passwordExpiresAt?: { toMillis(): number } | null } | null | undefined;

/** Única definição de "a troca de senha bloqueia a tela" (PasswordExpiredGate e AppLayout). */
export function passwordChangeRequired(userDoc: PasswordDoc, now: number): boolean {
  if (!userDoc) return false;
  const expiresAt = userDoc.passwordExpiresAt;
  return userDoc.mustChangePassword === true || (expiresAt ? expiresAt.toMillis() <= now : false);
}
